import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import DefaultMemberAvatar from '../../icons/defaultMemberAvatar';
import style from './Avatar.scss';
import { primaryColorOrDefault } from '../../reducers';
import {
  AVATARS,
  DEFAULT_GROUP_CHAT_AVATAR,
  DEFAULT_GROUP_CHAT_URL,
} from '../../constants/avatars';
import { Avatar as IAvatar, isImageAvatar, isSvgAvatar } from '@wix/chat-web';

interface AvatarProps {
  avatar: IAvatar;
  primaryColor: string;
  size?: number;
}

class Avatar extends React.Component<AvatarProps> {
  static defaultProps = {
    avatar: AVATARS.NONE.prop,
  };

  static defaultMemberAvatar = (<DefaultMemberAvatar />);

  dimensionStyles = () => {
    const { size } = this.props;

    if (!size) {
      return;
    }

    return {
      width: `${size}px`,
      height: `${size}px`,
    };
  };

  renderSvg(svg: ReactNode) {
    const { primaryColor } = this.props;

    return (
      <div
        data-hook={
          svg === Avatar.defaultMemberAvatar ? 'default-avatar' : 'svg-avatar'
        }
        className={classNames(style.avatar, style.svgAvatar)}
        style={{ color: primaryColor, ...this.dimensionStyles() }}
      >
        {svg}
      </div>
    );
  }

  renderImage(imgUrl: string) {
    return (
      <div
        data-hook="image-avatar"
        className={classNames(style.avatar, style.imageAvatar)}
        style={{
          backgroundImage: `url('${imgUrl}')`,
          ...this.dimensionStyles(),
        }}
      />
    );
  }

  getAvatarFromPropsWithDefault = (): IAvatar => {
    const { avatar } = this.props;
    if (isImageAvatar(avatar) && avatar.imgUrl === DEFAULT_GROUP_CHAT_URL) {
      return DEFAULT_GROUP_CHAT_AVATAR;
    }
    return avatar;
  };

  render() {
    const avatar = this.getAvatarFromPropsWithDefault();

    if (isSvgAvatar(avatar)) {
      return this.renderSvg(avatar.svg);
    }
    if (isImageAvatar(avatar)) {
      return this.renderImage(avatar.imgUrl);
    }
    return this.renderSvg(Avatar.defaultMemberAvatar);
  }
}

const mapStateToProps = (state) => ({
  primaryColor: primaryColorOrDefault(state),
});

export default connect(mapStateToProps)(Avatar);
